import React, { PropsWithChildren } from 'react'
import { AppContext, AppContextProvider } from 'src/context/AppContext'

// Cast avoids incorrect upstream typing that omits `children`
const ProviderAny = AppContextProvider as unknown as React.ComponentType<any>

type Props = PropsWithChildren<{ ctx: AppContext }>
export const WithAppContext: React.FC<Props> = ({ ctx, children }) => (
    <ProviderAny value={ctx}>{children}</ProviderAny>
)
